import React from 'react'
import GenericReport from '../GenericReport'

const JobCardSummaryPage: React.FC = () => {
  return <GenericReport reportId={7} />
}

export default JobCardSummaryPage
